import React, { useEffect, useRef } from "react";
import { MessageSquare, X, Sparkles, Circle } from "lucide-react";

// The running "notes" surface — every live transcript line, grouped by
// speaker. AI summary/action items are generated once, at meeting end
// (see /hirality-meetings/{id}/end) — this panel is the live raw feed.
export default function TranscriptPanel({ lines, connected, onClose, title = "Transcript & Notes" }) {
  const scrollRef = useRef(null);
  useEffect(() => {
    scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
  }, [lines]);

  return (
    <>
      <div style={{ padding: "16px 18px", borderBottom: "1px solid rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Circle size={8} fill={connected ? "#00E5A3" : "#FF4D6D"} color={connected ? "#00E5A3" : "#FF4D6D"}
            style={{ animation: connected ? "hmPulse 1.6s infinite" : "none" }} />
          <MessageSquare size={14} color="#00C8FF" />
          <span style={{ fontSize: 13, fontWeight: 700, color: "#E8F0FE" }}>{title}</span>
        </div>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#7A93B4" }}><X size={15} /></button>
      </div>

      <div ref={scrollRef} className="hm-scroll" style={{ flex: 1, overflowY: "auto", padding: "14px 18px" }}>
        {lines.length === 0 ? (
          <div style={{ textAlign: "center", color: "#3D5473", fontSize: 12.5, marginTop: 40 }}>
            <Sparkles size={20} style={{ marginBottom: 8, opacity: 0.6 }} />
            <div>Conversation will appear here as people speak.</div>
          </div>
        ) : lines.map((l, i) => {
          const prev = lines[i - 1];
          const showHeader = !prev || prev.speaker !== l.speaker;
          return (
            <div key={i} className="hm-line" style={{ marginBottom: 10 }}>
              {showHeader && <div style={{ fontSize: 11, fontWeight: 700, color: "#00C8FF", marginBottom: 2 }}>{l.speaker}</div>}
              <div style={{ fontSize: 13, color: "#E8F0FE", lineHeight: 1.5 }}>{l.text}</div>
            </div>
          );
        })}
      </div>

      <div style={{ padding: "10px 18px", borderTop: "1px solid rgba(255,255,255,0.06)", fontSize: 10.5, color: "#3D5473", textAlign: "center" }}>
        AI summary &amp; action items generate automatically when the meeting ends
      </div>
    </>
  );
}
